"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleGroup = toggleGroup;
exports.toggleQuantitySelector = toggleQuantitySelector;
function toggleGroup(propertiesSelectorId, groupName) {
    return {
        type: "genesys-properties-selector/TOGGLE_GROUP",
        propertiesSelectorId,
        groupName
    };
}
function toggleQuantitySelector(propertiesSelectorId, propertyName) {
    return {
        type: "genesys-properties-selector/TOGGLE_QUANTITY_SELECTOR",
        propertiesSelectorId,
        propertyName
    };
}
//# sourceMappingURL=actions.js.map